import { socialUrlForLink } from "./ProfileSocialBrand";

function LinkIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none">
      <path
        d="m15.988 13 3.902-3.902c1.437-1.437 1.485-3.718.107-5.095-1.377-1.378-3.658-1.33-5.095.107L11 8.012m2 7.95-3.892 3.88c-1.432 1.43-3.64 1.615-5.082.107-1.442-1.507-1.326-3.639.107-5.068L8.025 11M9 15l6-6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function LinkedInIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none">
      <path
        d="M3 9.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C6.04 3 7.16 3 9.4 3h5.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C21 6.04 21 7.16 21 9.4v5.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C17.96 21 16.84 21 14.6 21H9.4c-2.24 0-3.36-.436-4.216-1.748A4 4 0 0 1 3 14.6zm5-1.775v.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 16.375V10.75m4 5.625V13.5m0 0v-2.75m0 2.75c0-1.288 1.222-2 2.4-2 1.6 0 1.6 1.375 1.6 2.875v2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function InstagramIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none">
      <path
        d="M3 9.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C6.04 3 7.16 3 9.4 3h5.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C21 6.04 21 7.16 21 9.4v5.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C17.96 21 16.84 21 14.6 21H9.4c-2.24 0-3.36-.436-4.216-1.748A4 4 0 0 1 3 14.6zm14-2.9h.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.462 11.487a3.5 3.5 0 1 1-6.925 1.026 3.5 3.5 0 0 1 6.925-1.026"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function YoutubeIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none">
      <path
        d="M2 12c0-3.3 0-4.95 1.464-5.975C4.93 5 7.286 5 12 5s7.071 0 8.535 1.025S22 8.7 22 12s0 4.95-1.465 5.975C19.072 19 16.714 19 12 19s-7.071 0-8.536-1.025S2 15.3 2 12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 9.908v4.184a.41.41 0 0 0 .412.408.4.4 0 0 0 .228-.068l3.175-2.074a.405.405 0 0 0 .003-.678l-3.175-2.11a.415.415 0 0 0-.573.11.4.4 0 0 0-.07.228"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Whether the job has at least one company link to show. */
export function jobHasCompanyLinks(job) {
  const customs = Array.isArray(job?.socialProfiles?.customs) ? job.socialProfiles.customs : [];
  return Boolean(
    socialUrlForLink(job?.companyWebsite) ||
      socialUrlForLink(job?.socialProfiles?.linkedin) ||
      socialUrlForLink(job?.socialProfiles?.instagram) ||
      socialUrlForLink(job?.socialProfiles?.youtube) ||
      customs.some((row) => socialUrlForLink(row?.url))
  );
}

/**
 * Company website + social links for job detail header.
 */
export default function JobDetailCompanyLinks({ job, stacked = false }) {
  const companyWebsiteHref = socialUrlForLink(job?.companyWebsite);
  const companyLinkedinHref = socialUrlForLink(job?.socialProfiles?.linkedin);
  const companyInstagramHref = socialUrlForLink(job?.socialProfiles?.instagram);
  const companyYoutubeHref = socialUrlForLink(job?.socialProfiles?.youtube);
  const companyCustomLinks = Array.isArray(job?.socialProfiles?.customs) ? job.socialProfiles.customs : [];

  if (!jobHasCompanyLinks(job)) return null;

  const linksClass = stacked ? "job-company-links job-company-links--stack" : "job-company-links";

  return (
    <div className={linksClass} aria-label="Company links">
      {companyWebsiteHref ? (
        <a href={companyWebsiteHref} target="_blank" rel="noopener noreferrer" className="job-company-link">
          <span className="job-company-link-icon" aria-hidden="true">
            <LinkIcon />
          </span>
          <span>Website</span>
        </a>
      ) : null}
      {companyLinkedinHref ? (
        <a href={companyLinkedinHref} target="_blank" rel="noopener noreferrer" className="job-company-link">
          <span className="job-company-link-icon" aria-hidden="true">
            <LinkedInIcon />
          </span>
          <span>LinkedIn</span>
        </a>
      ) : null}
      {companyInstagramHref ? (
        <a href={companyInstagramHref} target="_blank" rel="noopener noreferrer" className="job-company-link">
          <span className="job-company-link-icon" aria-hidden="true">
            <InstagramIcon />
          </span>
          <span>Instagram</span>
        </a>
      ) : null}
      {companyYoutubeHref ? (
        <a href={companyYoutubeHref} target="_blank" rel="noopener noreferrer" className="job-company-link">
          <span className="job-company-link-icon" aria-hidden="true">
            <YoutubeIcon />
          </span>
          <span>YouTube</span>
        </a>
      ) : null}
      {companyCustomLinks
        .slice(0, 6)
        .map((row) => ({
          id: row?.id,
          label: String(row?.platformName || "").trim() || "Link",
          href: socialUrlForLink(row?.url),
        }))
        .filter((row) => row.href)
        .map((row) => (
          <a
            key={row.id || row.href}
            href={row.href}
            target="_blank"
            rel="noopener noreferrer"
            className="job-company-link"
          >
            <span className="job-company-link-icon" aria-hidden="true">
              <LinkIcon />
            </span>
            <span>{row.label}</span>
          </a>
        ))}
    </div>
  );
}
